import { takeEvery } from 'redux-saga/effects'
import { putPromise } from '../../../helpers/redux'
import * as actions from './actions'
import { listDocs } from './actions'

/**
 * After any successful mutation, refresh the list so the table reflects the change.
 * (Update also updates `selected` via the reducer.)
 */
export function* refreshDocsAfterMutation() {
  yield takeEvery(
    [
      actions.ADD_DOC_SUCCESS,
      actions.UPDATE_DOC_SUCCESS,
      actions.DELETE_DOC_SUCCESS,
      actions.REINGEST_DOC_SUCCESS,
    ],
    function* () {
      yield putPromise(listDocs())
    },
  )
}
